/**
 * Security settings section wrapper — password and two-factor authentication.
 */

import { useCallback } from 'react';

import { useOrg } from '@/contexts/OrgContext';
import {
  useInvalidateUserProfile,
  useUserProfileData,
} from '@/hooks/useUserProfileData';
import { useViewHealthMarker } from '@/lib/view-health';

import { useUser } from '../../../../allauth_auth';
import { SecuritySection as SecuritySectionInner } from '../../profile/components/SecuritySection';

export function SecuritySection() {
  const { currentOrg } = useOrg();
  const user = useUser();
  const { data: profileData } = useUserProfileData();
  const invalidateUserProfile = useInvalidateUserProfile();
  useViewHealthMarker('settings-section-ready', { ready: !!profileData });

  const has2FA = profileData?.user_has_valid_totp_device ?? false;
  const hasPassword = user?.has_usable_password ?? false;
  const orgId = currentOrg?.id ?? 0;

  const handleRefresh = useCallback(
    () => invalidateUserProfile(),
    [invalidateUserProfile]
  );

  return (
    <div className='space-y-8'>
      <div>
        <h2 className='text-lg font-semibold text-fg-primary'>Security</h2>
        <p className='text-sm text-fg-tertiary mt-0.5'>
          Manage your password and two-factor authentication.
        </p>
      </div>
      <div>
        <SecuritySectionInner
          orgId={orgId}
          has2FA={has2FA}
          hasPassword={hasPassword}
          onRefresh={handleRefresh}
        />
      </div>
    </div>
  );
}
